// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7882a2c4","709":"1d1bbadc","926":"9df124ea"}[chunkId] + ".chunk.js";
};